// src/components/Common/popupUIStore.js
import { openStaffChatWorkspace } from "../../stores/staffChatWorkspaceStore";

let currentPopup = null;
const listeners = new Set();

let __id = 0;

function emit() {
   listeners.forEach((cb) => {
      try {
         cb();
      } catch {}
   });
}

export function subscribePopup(cb) {
   listeners.add(cb);
   return () => listeners.delete(cb);
}

export function getCurrentPopup() {
   return currentPopup;
}

// Mesajele ca panou plutitor (se retrage fără să se închidă, lasă alte
// ferestre să se deschidă) sunt doar pentru admin și manager; ceilalți
// (elevi, instructori, profesori) le deschid ca pe orice altă fereastră.
// Se setează din AppShell, după rolul utilizatorului.
let staffChatAsWorkspace = false;

export function setStaffChatAsWorkspace(enabled) {
   staffChatAsWorkspace = Boolean(enabled);
}

export function openPopup(type, props = {}) {
   // Message workspace is a dedicated floating panel — keep it out of the
   // exclusive popup stack so other popups can open without killing the chat.
   if (type === "staffChat" && staffChatAsWorkspace) {
      openStaffChatWorkspace(props);
      return;
   }
   currentPopup = { id: ++__id, type, props };
   emit();
}

export function closePopup() {
   currentPopup = null;
   emit();
}

/* subpopup stack (opțional, îl lași dacă vrei) */
let __subStack = [];
const __subListeners = new Set();

function __emitSub(action = "set") {
   const top = __subStack[__subStack.length - 1] || null;
   const depth = __subStack.length;
   __subListeners.forEach((cb) => {
      try {
         cb({ detail: top, depth, action });
      } catch {}
   });
}

// Același tip ca cel de deasupra (ex. altă rezervare din listă): îl înlocuiește, nu se mai adună
// unul peste altul — altfel 10 rezervări deschise cer 10 închideri. Alt tip se pune deasupra.
export function openSubPopup(type, props = {}) {
   const top = __subStack[__subStack.length - 1];
   if (top && top.type === type) {
      __subStack[__subStack.length - 1] = { type, props };
      __emitSub("replace");
      return;
   }
   __subStack.push({ type, props });
   __emitSub("set");
}

export function closeSubPopup() {
   const depth = __subStack.length;
   __subListeners.forEach((cb) =>
      cb({ detail: null, depth, action: "request-close" }),
   );
}

export function popSubPopup() {
   __subStack.pop();
   __emitSub("set");
}

export function getCurrentSubPopup() {
   return __subStack[__subStack.length - 1] || null;
}

export function subscribeSubPopup(cb) {
   __subListeners.add(cb);
   return () => __subListeners.delete(cb);
}
